module.exports = __webpack_public_path__ + "static/media/step5.b356f6e7.png";